<template>
	<div id="app">
		<div v-if="offline" id="offline">OFFLINE</div>
		<router-view/>
		<floating-boxes/>
		<install-app/>
		<!-- <introduction/> -->
		<app-modal/>
		<app-toast/>
		<footer class="sk-simple__footer">
			<img class="sk-simple__logo" src="../static/img/pt/logof.png" alt="">
			<div class="sk-simple__logo-text">Smart Care | Todos os direitos reservados</div>
			<a class="sk-simple__link-pp" target="_blank" href="https://www.telecom.pt/pt-pt/Paginas/politica-privacidade.aspx">Política de Privacidade</a>
		</footer>
	</div>
</template>

<script>
import HelpContent from '@/components/help/HelpContent'
import InstallApp from '@/components/install/InstallApp'
import Introduction from '@/components/intro/Introduction'
export default {
	name: 'App',
	components: {
		HelpContent,
		InstallApp,
		Introduction
	},
	computed: {
		offline () {
			return !this.$root.online;
		}
	}
}
</script>

<style scoped>
	.sk-simple__footer {
		display: flex;
		flex-direction: row;
		background-color: #3F3F3F;
		_border-top: 2px solid var(--main-color);
		border-top: 2px solid #fff;
		width: 100%;
		height: 100%;
		align-items: center;
		padding: 0 20px;
		overflow: hidden;
		position: fixed;
		height: 50px;
		bottom: 0;
		z-index: 10;
	}
	.sk-simple__logo-e {
		width: 250px;
	}
	.sk-simple__logo {
		width: 80px;
	}
	.sk-simple__logo-text {
		flex: 1;
		color: #fff;
		margin: 0 20px;
	}
	.sk-simple__link-pp {
		color: #fff;
	}

	@media screen and (max-width: 1024px) {
		.sk-simple__logo-text {
			font-size: 9.5px;
		}
		.sk-simple__link-pp {
			font-size: 9.5px;
		}
	}
</style>



// WEBPACK FOOTER //
// src/App.vue